import React ,{useEffect} from "react";
import { Accordion, Card } from "react-bootstrap";
import {Shape} from "./Basic/Shape"
import { Carat } from "./Basic/Carat";
import {Color} from "./Basic/Color"
import { Clarity } from "./Basic/Clarity";
import { Lab } from "./Basic/Lab";
import { LabLab } from "./Basic/LabLab";
import { Shortcut } from "./Basic/Shortcut";
import { Finish } from "./Basic/Finish";
import { Flour } from "./Basic/Flour";
import { Location } from "./Basic/Location";
import { Availibility } from "./Basic/Availibility";
export const Basic = ({formik,language,option,diamond_type,oldvalues,errorMsg,setErrorMsg}) => {
        useEffect(() => {
            for(let key in oldvalues){
                formik.setFieldValue(key,oldvalues[key])
            }
            if(!oldvalues.Min_Price_changed){
                formik.setFieldValue("Min_Price", "")
            }

            if(!oldvalues.priceTo_changed){
                formik.setFieldValue("priceTo", "")
            }
        },[])
        console.log(formik.values)
       return (
        <>
            <Accordion className="search_accordion" defaultActiveKey="1">
                <Card>
                    <Accordion.Toggle  as={Card.Header} eventKey="1" key="1">
                        {language.BASIC_BASIC}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                        <Card.Body >
                            <Shape errorMsg={errorMsg} setErrorMsg={setErrorMsg} language={language} formik={formik}/>
                            <Carat errorMsg={errorMsg} setErrorMsg={setErrorMsg} language={language} formik={formik} oldvalues={oldvalues}/>
                            <Color language={language} formik={formik} option={option}/>
                            <Clarity language={language}/>
                            {diamond_type === "L" ? <LabLab language={language} diamond_type={diamond_type} formik={formik}/> : <Lab language={language} diamond_type={diamond_type} formik={formik}/>}
                            <Finish language={language}/>
                            <Flour language={language}/>
                            {/* <Availibility  language={language}/> */}
                            <Shortcut language={language} formik={formik} option={option}/>
                            <Location language={language} diamond_type={diamond_type} formik={formik}/>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </>
    );
};
